import React, { useState } from "react";
import { useSelector } from "react-redux";

import { getIcon } from "../../../helpers/icons";
import { formatDate } from "../../../helpers/date";
import { downloadSrcGenerator } from "../../../helpers/media";
import Link from "../../../components/Link";
import Title from "../../../components/Title";
import Rating from "../../../components/Rating";
import Editor from "../../../components/Editor";
import Section from "../../../components/Section";
import ReadTime from "../../../components/ReadTime";
import IconLabel from "../../../components/IconLabel";
import DialogBox from "../../../components/DialogBox";
import ArticleSave from "../../../components/ArticleSave";
import CategoryList from "../../../components/CategoryList";
import Feedback from "../../../components/DialogBox/Feedback"
import ShareDialog from "../../../components/DialogBox/ShareDialog";

import style from "./style.module.css";

export default function ArticleTextContent( props ) {

    const { 
        id, 
        name, 
        time_duration = "", 
        long_description = "", 
        author_name = "", 
        publish_date = "", 
        media_download = 0, 
        transcript = "", 
        transcript_download = 0, 
        media_type = "", 
        content_type = "", 
        audio_file = {}, 
        video_file = {}, 
        document_file = {}, 
        themes = [], 
        categories = [], 
        tags = [],
        rating = null, 
    } = props;

    const userProfile = useSelector((state) => state.storage.data);
    const date = formatDate(publish_date);
    const [popup, setPopup] = useState(false);
    const downloadLink = downloadSrcGenerator({ name, content_type, media_type, audio_file, video_file, document_file });

    return (
        <>
            <Section className={style.articleTextContent}>
                <div className={style.articleTextContentWrap}>
                    <div className={style.sectionRow}>
                        <div className={style.sectionHeader}>
                            <div className={style.colRow}>
                                <div className={style.col2}>
                                    <Title className="fontTeko" tag="h2" transform="uppercase">{name}</Title>
                                </div>
                                <div className={style.col2}>
                                    <div className={style.btnRow}>
                                        <Rating type="article" id={id} rating={rating} />
                                        {
                                            (media_download !== 0 && downloadLink !== "") && (
                                                <Link 
                                                    download={true} to={downloadLink}
                                                >
                                                    <i className={getIcon("Download")}></i> Download
                                                </Link>
                                            )
                                        }
                                        {
                                            transcript !== "" && transcript !== null && (
                                                <Link 
                                                    onClick={() => { setPopup("transcript") }}
                                                >
                                                    <i className={getIcon("Document")}></i> Transcript
                                                </Link>
                                            )
                                        }
                                        {
                                            userProfile.id !== undefined ? (
                                                <Link 
                                                    onClick={() => { setPopup("feedback") }}
                                                >
                                                    <i className={getIcon("Feedback")}></i> Feedback
                                                </Link>
                                            ) : (
                                                <Link 
                                                   to={`/sign-in?redirect=${window.location.pathname}`}
                                                >
                                                    <i className={getIcon("Feedback")}></i> Feedback
                                                </Link>
                                            )
                                        }
                                        <ArticleSave id={id} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={style.sectionBody}>
                            <div className={style.articleSubDetails}>
                                <div className={style.iconList}>
                                    <div className={style.categoryRow}>
                                        {
                                            author_name !== null && author_name !== "" && (
                                                <IconLabel icon="User" label={author_name} />
                                            )
                                        }
                                        <IconLabel icon="Calendar" label={date} />
                                    </div>
                                </div>
                                <div className={style.iconList}>
                                    {
                                        categories.length > 0 && (
                                            <CategoryList item={categories} type="category" tag="p" />
                                        )
                                    }
                                    {
                                        themes.length > 0 && (
                                            <CategoryList item={themes} tag="p" />
                                        )
                                    }
                                    <ReadTime time={time_duration} />
                                    {
                                        tags.length > 0 && (
                                            <CategoryList item={tags} tag="p" />
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                        <div className={style.sectionFooter}>
                            <div className={style.longDescription}>
                                <Editor text={long_description} />
                            </div>
                        </div>
                    </div>
                </div>
            </Section>
            {
                popup === "transcript" && (
                    <DialogBox
                        onClose={() => setPopup(false)}
                        className={`${style.articlePopup} ${style.transcriptPopup}`}
                        title={false}
                        headerClass={style.dialogBoxHeader}
                        modalClassName={style.articleModal}
                        buttonClassName={style.customCloseStyle}
                        render={() => {
                            return (
                                <Feedback name={name} transcript={transcript} download={transcript_download} />
                            )
                        }}
                    />
                )
            }
            {
                popup === "share" && (
                    <ShareDialog onClose={() => { setPopup(false) }} />
                )
            }
            {
                popup === "feedback" && (
                    <DialogBox
                        onClose={() => setPopup(false)}
                        className={`${style.articlePopup}`}
                        title={false}
                        headerClass={style.dialogBoxHeader}
                        modalClassName={style.articleModal}
                        buttonClassName={style.customCloseStyle}
                        hasCloseIcon={false}
                        render={({closeDialog}) => {
                            return (
                                <Feedback id={id} closeDialog={closeDialog} type="feedback" />
                            )
                        }}
                    />
                )
            }
        </>
    )
}